import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable, Subject} from 'rxjs';
import {distinctUntilChanged, map, switchMap} from 'rxjs/operators';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MapService {
  private geocodeUrl = `${environment.apiUrl}/geocode/search`;
  private reverseGeocodeUrl = `${environment.apiUrl}/geocode/reverse`;
  public querySubject$: Subject<string> = new Subject();
  public queryObservable: Observable<any>;


  constructor(private http: HttpClient) {
    this.queryObservable = this.subscribeToQuerySubject();
  }

  searchPlaces(query: string): void{
    this.querySubject$.next(query);
  }

  public reverseGeocode(lat: number, lng: number): Observable<any> {
    return this.http.get(this.reverseGeocodeUrl, {params: {lat, lon: lng}});
  }
  public subscribeToQuerySubject(): Observable<any> {
    return this.querySubject$.pipe(
      distinctUntilChanged(),
      switchMap((query: string): Observable<any> => {
        return this.http.get(this.geocodeUrl, {params: {q: query}});
      }));
  }

  getCoordinates(location: string, language: string): Observable<any> {
    const params = {
      q: location,
      language
    };
    return this.http.get<any[]>(this.geocodeUrl, { params })
      .pipe(map(results => results[0]));
  }
}
